<template>
    <div class="tw-flex-1">
        <div v-bar>
            <div>
                <div class="tw-text-center tw-flex tw-flex-col tw-flex-1 tw-items-center tw-justify-center">
                    <div class="quiz-end-message tw-text-green-500" v-if="quizSettings.is_rated !== '1'">
                        <i class="fa fa-check-circle tw-pr-2"></i>
                        <h2>{{ translations['quiz.have_finished'] }}</h2>
                    </div>
                    <template v-else>
                        <div class="quiz-end-message tw-text-green-500" v-if="passed_quiz">
                            <i class="fa fa-check-circle tw-pr-2"></i>
                            <h2>{{ translations['quiz.passed'] }}</h2>
                        </div>
                        <div v-else class="quiz-end-message tw-text-red-500">
                            <i class="fa fa-times tw-pr-2"></i>
                            <h2>{{ translations['quiz.failed'] }}</h2>
                        </div>
                    </template>
                    <h3 class="tw-pb-6 tw-leading-loose tw-px-8">
                        <b>{{ getAmountOfCorrectAnswers }}</b> {{ translations['quiz.out_of'] }} <b>{{ getAmountOfQuestions }}</b> {{ translations['quiz.answers_correct'] }}
                        <template v-if="!passed_quiz && quizSettings.is_rated === '1'">
                            <br />{{ translations['quiz.you_scored'] }} <b>{{ score }}</b> {{ translations['quiz.of_possible'] }} <b>{{ max }}</b> {{ translations['quiz.whilst'] }} <b>{{ scoreToPass }}</b> {{ translations['quiz.were_required'] }}.
                        </template>
                    </h3>
                    <p class="tw-text-gray-300 tw-text-sm tw-leading-loose" v-if="current_question_index+1 === getAmountOfQuestions && quizSettings.back_forward === '1' && quizSettings.direct_feedback === '1'">
                        {{ translations['quiz.safe_back'] }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState,mapGetters} from 'vuex';
import Global from '../../../mixins/Global.js';

export default {
	mixins: [Global],
	name: 'QuizEnd',

	computed: {
		...mapState('quiz',
			['quizSettings','score','max','passed_quiz','percentage', 'current_question_index']
		),

		...mapGetters('quiz', [
			'getAmountOfCorrectAnswers',
			'getAmountOfQuestions',
		]),

		scoreToPass() {
			return Math.ceil((this.max * this.quizSettings.threshold) / 100);
		}
	}
};
</script>

<style lang="scss" scoped>
	.quiz-end-message {
		@apply tw-flex tw-items-center tw-text-xl tw-font-bold tw-px-4 tw-pb-6 tw-mb-6;
	}

    .vb {
        height: 100%;
    }

    .vb-content {
        display: flex !important;
    }

    h2 {
        color: inherit !important;
        font-size: 1.35rem !important;
        font-weight: 600;
    }

    h3 {
        color: #7d7b7b !important;
        font-size: 1.1rem !important;
        font-weight: 400;
    }

    p {
        font-size: 1.05rem !important;
        color: #a9a7a7 !important;
    }
</style>